import { HStack, Text } from '@chakra-ui/react';

import { Image } from '@nocowanie/common-ui';

import { CreditCardListProps } from './credit-card-list.props';

export const CreditCardList = ({ description, creditCards = [] }: CreditCardListProps) => {
    return creditCards.length ? (
        <>
            {description && (
                <Text mt={6} mb={2} fontSize={'xs'}>
                    {description}
                </Text>
            )}
            <HStack gap={3}>
                {creditCards.map(({ imageSrc, name, cardId }) => (
                    <Image src={imageSrc} key={cardId} alt={name} />
                ))}
            </HStack>
        </>
    ) : null;
};
